module.exports = __webpack_public_path__ + "static/media/cp8.32c22843.png";